<template>
  <v-flex xs12 class="projectsComponent" style="position: relative">
    <v-flex v-if="loading" style="position: absolute; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;z-index: 9;">
      <v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex v-if="trendingProjects && trendingProjects.length > 0" style="padding: 40px 0 40px 0; margin-left: 5%; font-size: 24px; font-weight: 700; display: flex; justify-content: space-between; align-items: baseline" :style="getHeaderWidth" :class="loading ? 'blurClass' : ''">
      <div class="primary--text">Most active projects</div>
      <div @click="goToSearch('trending')" style="font-size: 18px; font-weight: 500; cursor: pointer" class="primary--text">See All</div>
    </v-flex>
    <v-flex v-if="trendingProjects && trendingProjects.length > 0" class="trendingProjectsContainer" id="trendingProjectsContainer" v-resize="onResize" :class="loading ? 'blurClass' : ''">
      <v-flex v-for="(item, index) in trendingProjects" :key="index" v-if="index < numberOfElements" style="flex:none" @click="toggleSubscriptionPanelTrending(item)">
        <div class="projectCard" :style="{ 'background-image': 'url(' + item.config.unsplashImageUrl + ')' }">
          <div class="projectOverlay"></div>
          <div class="projectInfo">
            <div class="projectName secondary--text">{{item.name}}</div>
            <div class="projectOrganization secondary--text">{{getOrganizationName(item)}}</div>
          </div>
          <div class="projectArrow secondary--text" v-if="selectedTrendingProject && selectedTrendingProject.id === item.id"><div class="projectArrowDown"></div></div>
        </div>
      </v-flex>
      <div class="projectPanel primary mb-2" v-if="selectedTrendingProject" :style="'width: ' + panelWidth + 'px'">
        <ProjectPanel v-on:manage-project="manageProject(selectedTrendingProject)" v-on:manage-users="manageUsers(selectedTrendingProject)" v-on:subscribe="subscribeToProject" v-bind:options="{project: selectedTrendingProject, trending: true}"></ProjectPanel>
        </div>
    </v-flex>
    <v-flex v-if="popularProjects && popularProjects.length > 0" style="padding: 40px 0 40px 0; margin-left: 5%; font-size: 24px; font-weight: 700; display: flex; justify-content: space-between; align-items: baseline" :style="getHeaderWidth" :class="loading ? 'blurClass' : ''">
      <div class="primary--text">Popular projects</div>
      <div @click="goToSearch('popular')" style="font-size: 18px; font-weight: 500; cursor: pointer" class="primary--text">See All</div>
    </v-flex>
    <v-flex v-if="popularProjects && popularProjects.length > 0" class="popularProjectsContainer" id="popularProjectsContainer" :class="loading ? 'blurClass' : ''">
      <v-flex v-for="(item, index) in popularProjects" :key="index" v-if="index < numberOfElements" style="flex:none" @click="toggleSubscriptionPanelPopular(item)">
        <div class="projectCard" :style="{ 'background-image': 'url(' + item.config.unsplashImageUrl + ')' }">
          <div class="projectOverlay"></div>
          <div class="projectInfo">
            <div class="projectName secondary--text">{{item.name}}</div>
            <div class="projectOrganization secondary--text">{{getOrganizationName(item)}}</div>
          </div>
          <div class="projectArrow secondary--text" v-if="selectedPopularProject && selectedPopularProject.id === item.id"><div class="projectArrowDown"></div></div>
        </div>
      </v-flex>
      <div class="projectPanel primary mb-2" v-if="selectedPopularProject" :style="'width: ' + panelWidth + 'px'">
        <ProjectPanel v-on:manage-project="manageProject(selectedPopularProject)" v-on:manage-users="manageUsers(selectedPopularProject)" v-on:subscribe="subscribeToProject" v-bind:options="{project: selectedPopularProject, popular: true}"></ProjectPanel>
        </div>
    </v-flex>
    <v-flex v-if="isLoggedIn && recommendedProjects && recommendedProjects.length > 0" style="padding: 40px 0 40px 0; margin-left: 5%; font-size: 24px; font-weight: 700; display: flex; justify-content: space-between; align-items: baseline" :style="getHeaderWidth" :class="loading ? 'blurClass' : ''">
      <div class="primary--text">Recommended projects</div>
      <div @click="$router.push({path: '/search', query: {input: '', category: popularCategory, display: 'search', order: 'DESC', type: 'recommended'}})" style="font-size: 18px; font-weight: 500; cursor: pointer" class="primary--text">See All</div>
    </v-flex>
    <v-flex v-if="isLoggedIn && recommendedProjects && recommendedProjects.length > 0" class="recommendedProjectsContainer" id="recommendedProjectsContainer" :class="loading ? 'blurClass' : ''">
      <v-flex v-for="(item, index) in recommendedProjects" :key="index" v-if="index < numberOfElements" style="flex:none" @click="toggleSubscriptionPanelRecommended(item)">
        <div class="projectCard" :style="{ 'background-image': 'url(' + item.config.unsplashImageUrl + ')' }">
          <div class="projectOverlay"></div>
          <div class="projectInfo">
            <div class="projectName secondary--text">{{item.name}}</div>
            <div class="projectOrganization secondary--text">{{getOrganizationName(item)}}</div>
          </div>
          <div class="projectArrow secondary--text" v-if="selectedRecommendedProject && selectedRecommendedProject.id === item.id"><div class="projectArrowDown"></div></div>
        </div>
      </v-flex>
      <div class="projectPanel primary mb-2" v-if="selectedRecommendedProject" :style="'width: ' + panelWidth + 'px'">
        <ProjectPanel v-on:manage-project="manageProject(selectedRecommendedProject)" v-on:manage-users="manageUsers(selectedRecommendedProject)" v-on:subscribe="subscribeToProject" v-bind:options="{project: selectedRecommendedProject, recommended: true}"></ProjectPanel>
        </div>
    </v-flex>
    <v-flex v-if="trendingCategories && trendingCategories.length > 0" style="padding: 40px 5%; font-size: 24px; font-weight: 700" class="primary--text" :class="loading ? 'blurClass' : ''">Popular categories</v-flex>
    <v-flex v-if="trendingCategories && trendingCategories.length > 0" class="popularCategoriesContainer mb-5" id="popularCategoriesContainer" :class="loading ? 'blurClass' : ''">
      <v-chip @click="$router.push({path: '/search', query: {input: '', category: item, display: 'search', order: 'DESC'}})" v-for="(item, index) in trendingCategories" :key="index" class="primary secondary--text categoryChip">{{item}}</v-chip>
    </v-flex>
    <v-dialog
      v-if="isLoggedIn && selectedProject"
      v-model="subscribeDialog"
      persistent
      scrollable
      fullscreen
      transition="dialog-transition"
    >
      <Subscribe v-on:close-subscribe-dialog="subscribeDialog = false; selectedProject = null" v-bind:options="{project: selectedProject, planId: selectedPlanId, dialogType: dialogType}"></Subscribe>
    </v-dialog>
    <v-dialog
      v-if="selectedProject"
      v-model="manageDialog"
      persistent
      fullscreen
      transition="dialog-transition"
    >
      <ManageProject v-on:close-manage-dialog="manageDialog = false; selectedProject = null" v-bind:options="{project: selectedProject}"></ManageProject>
    </v-dialog>
  </v-flex>
</template>

<style>
  .blurClass{
    -webkit-filter: blur(5px);
    filter: blur(5px);
  }
  .categoryChip span{
    cursor: pointer !important;
  }
  .projectPanel{
    height: 500px;
    position: relative;
    transition: 400ms all ease-in-out;
  }
  .trendingProjectsContainer, .popularProjectsContainer, .recommendedProjectsContainer, .popularCategoriesContainer{
    padding: 0 5%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  .projectsComponent .projectArrow{
    position: absolute;
    top: 100%;
    margin-top: 5px;
    left: 0;
    right: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    z-index: 9
  }
  .projectsComponent .projectArrowDown{
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 15px solid white;
  }
  .projectCard{
    position: relative;
    width: 260px;
    height: 160px;
    flex: none;
    margin-bottom: 5px;
    margin-right: 5px;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
  .projectTitle{
    width: 100%;
    text-align: center;
    font-size: 36px;
    font-weight: 800;
  }
  .projectsCards{
    position: relative;
    width: 100%;
  }
  .projectContainer{
    position: relative;
    flex: none;
  }
  .projectOverlay{
    background: #000000;
    opacity: 0.5;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 4;
  }
  .projectInfo{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 25px;
    z-index: 6;
  }
  .projectName{
    font-size: 18px;
    font-weight: 700;
  }
  .projectOrganization{
    font-weight: 500;
    font-size: 12px;
  }
  .projectsComponent{
    margin-bottom: 60px;
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import ProjectPanel from './appElements/ProjectPanel.vue'
import Subscribe from './Subscribe.vue'
import ManageProject from './appElements/ManageProject.vue'

export default {
  data () {
    return {
      trendingProjects: [],
      numberOfElements: 3,
      trendingTimePeriod: 7,
      selectedTrendingProject: null,
      panelWidth: 0,
      popularProjects: [],
      selectedPopularProject: null,
      popularCategory: '',
      recommendedProjects: null,
      selectedRecommendedProject: null,
      trendingCategories: [],
      selectedProject: null,
      subscribeDialog: false,
      projects: [],
      selectedPlanId: null,
      dialogType: 'projects',
      manageDialog: false,
      loading: false
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    goToSearch (category) {
      this.$router.push({path: '/search', query: {display: 'category', order: 'DESC', type: category}})
    },
    manageProject (project) {
      this.selectedProject = project
      this.manageDialog = true
    },
    manageUsers (project) {
      this.selectedProject = project
      this.dialogType = 'users'
      this.subscribeDialog = true
    },
    subscribeToProject (subscriptionObject) {
      this.selectedProject = this.projects.find(item => { return item.id === subscriptionObject.projectId })
      this.selectedPlanId = subscriptionObject.planId
      this.subscribeDialog = true
      this.dialogType = 'projects'
    },
    getProjects () {
      this.loading = true
      var today = new Date()
      this.projects = []
      var todayQueryString = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      var timePeriodStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - this.trendingTimePeriod)
      var timePeriodStartQueryString = timePeriodStart.getFullYear() + '-' + (timePeriodStart.getMonth() + 1) + '-' + timePeriodStart.getDate()
      this.trendingProjects = []
      axios.all([this.$store.dispatch('getProjectsWithAllAndStatsPublic', '?sortBy=_total_subscriptions%20desc,_date_added%20desc&projectStatus=Active&pageSize=15&fromDate=' + timePeriodStartQueryString + '&toDate=' + todayQueryString), this.$store.dispatch('getProjectsWithAllAndStatsPublic', '?sortBy=_total_subscriptions%20desc,_date_added%20desc&pageSize=15&projectStatus=Active')]).then(axios.spread((trendingResponse, popularResponse) => {
        if (trendingResponse.data.status === 'SUCCESS' && popularResponse.data.status === 'SUCCESS') {
          this.loading = false
          if (trendingResponse.data.payload && trendingResponse.data.payload.length > 0) {
            this.trendingProjects = trendingResponse.data.payload
            this.projects = this.projects.concat(trendingResponse.data.payload)
            this.getTrendingCategories(trendingResponse.data.payload)
            if (this.$route.query.trending) {
              var trendingProject = this.trendingProjects.find(item => { return item.id === Number(this.$route.query.projectId) })
              if (trendingProject) {
                this.toggleSubscriptionPanelTrending(trendingProject)
              }
            } else {
              this.toggleSubscriptionPanelTrending(this.trendingProjects[0])
            }
          }
          if (popularResponse.data.payload && popularResponse.data.payload.length > 0) {
            this.projects = this.projects.concat(popularResponse.data.payload)
            this.popularProjects = popularResponse.data.payload
            if (this.$route.query.popular) {
              var popularProject = this.popularProjects.find(item => { return item.id === Number(this.$route.query.projectId) })
              if (popularProject) {
                this.toggleSubscriptionPanelPopular(popularProject)
              }
            }
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loading = false
        console.log(err)
      })
      if (this.isLoggedIn) {
        axios.all([this.$store.dispatch('getProjectsWithAllPublic', '?sortBy=_date_added&projectStatus=Active&order=DESC&category=' + this.popularCategory + '&pageSize=15')]).then(axios.spread((recommendedResponse) => {
          if (recommendedResponse.data.status === 'SUCCESS') {
            if (recommendedResponse.data.payload && recommendedResponse.data.payload.length > 0) {
              this.projects = this.projects.concat(recommendedResponse.data.payload)
              this.recommendedProjects = recommendedResponse.data.payload
              if (this.$route.query.recommended) {
                var project = this.recommendedProjects.find(item => { return item.id === Number(this.$route.query.projectId) })
                if (project) {
                  this.toggleSubscriptionPanelRecommended(project)
                }
              }
            }
          } else {
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            this.loading = false
          }
        })).catch((err) => {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
          console.log(err)
        })
      }
    },
    toggleSubscriptionPanelTrending (project) {
      if (!this.selectedTrendingProject || (this.selectedTrendingProject && project.id !== this.selectedTrendingProject.id)) {
        this.onResize()
        this.selectedTrendingProject = project
      } else {
        this.selectedTrendingProject = null
      }
    },
    toggleSubscriptionPanelPopular (project) {
      if (!this.selectedPopularProject || (this.selectedPopularProject && project.id !== this.selectedPopularProject.id)) {
        this.onResize()
        this.selectedPopularProject = project
      } else {
        this.selectedPopularProject = null
      }
    },
    toggleSubscriptionPanelRecommended (project) {
      if (!this.selectedRecommendedProject || (this.selectedRecommendedProject && project.id !== this.selectedRecommendedProject.id)) {
        this.onResize()
        this.selectedRecommendedProject = project
      } else {
        this.selectedRecommendedProject = null
      }
    },
    getOrganizationName (project) {
      var organization = project.organizations.find(item => { return item.id === project.createdByOrganizationId })
      if (organization) {
        return organization.name
      }
      return ''
    },
    onResize () {
      if (document.getElementById('popularProjectsContainer')) {
        this.numberOfElements = Math.floor((document.getElementById('popularProjectsContainer').offsetWidth - (document.getElementById('popularProjectsContainer').offsetWidth * 0.1)) / 265)
        this.panelWidth = (265 * this.numberOfElements) - 5
      }
    },
    getMostPopularCategory () {
      var projectCategories = []
      for (var i = 0; i < this.getProjectCategories.length; i++) {
        projectCategories.push(0)
      }
      var self = this
      this.getUserOrganization.projects.forEach(function (project) {
        for (var c = 0; c < project.config.categories.length; c++) {
          projectCategories[self.getProjectCategories.indexOf(project.config.categories[c])] += 1
        }
      })
      var maxUsed = Math.max(...projectCategories)
      var maxUsedIndex = projectCategories.indexOf(maxUsed)
      this.popularCategory = this.getProjectCategories[maxUsedIndex]
    },
    getTrendingCategories (projects) {
      var projectCategories = []
      for (var i = 0; i < this.getProjectCategories.length; i++) {
        projectCategories.push(0)
      }
      var self = this
      projects.forEach(function (project) {
        for (var c = 0; c < project.config.categories.length; c++) {
          projectCategories[self.getProjectCategories.indexOf(project.config.categories[c])] += 1
        }
      })
      this.trendingCategories = []
      for (var p = 0; p < projectCategories.length; p++) {
        if (projectCategories[p] !== 0) {
          this.trendingCategories.push(this.getProjectCategories[p])
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      getProjectCategories: 'getProjectCategories',
      getUserOrganization: 'getUserOrganization'
    }),
    getHeaderWidth () {
      var width = this.panelWidth === 0 ? '100%' : this.panelWidth + 'px'
      return 'width: ' + width
    }
  },
  components: {
    ProjectPanel,
    Subscribe,
    ManageProject
  },
  mounted () {
    this.getProjects()
    if (this.$route.query.trending) {
      var trendingProject = this.trendingProjects.find(item => { return item.id === Number(this.$route.query.projectId) })
      if (trendingProject) {
        this.toggleSubscriptionPanelTrending(trendingProject)
      }
    }
    if (this.$route.query.popular) {
      var popularProject = this.popularProjects.find(item => { return item.id === Number(this.$route.query.projectId) })
      if (popularProject) {
        this.toggleSubscriptionPanelPopular(popularProject)
      }
    }
    if (this.isLoggedIn && this.getUserOrganization && this.getUserOrganization.projects) {
      this.getMostPopularCategory()
      if (this.$route.query.recommended) {
        var project = this.recommendedProjects.find(item => { return item.id === Number(this.$route.query.projectId) })
        if (project) {
          this.toggleSubscriptionPanelRecommended(project)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Market.vue